export default __webpack_public_path__ + "static/IBM-Plex-Mono-600-384c2ed41ea602a5cb62c6eb1b08fc94.woff";